import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import youtubeImg from "../images/youtube.svg";
import behanceImg from "../images/behance.svg";

export default function Youtube() {
  return (
  <Container className="mb-3 pb-3">
  <Row className="g-4">

    {/* Behance */}
    <Col lg={4} md={12}>
      <a
        href="https://www.behance.net/divyatailang"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolioCard"
      >
        <h2 className="sectionTitle">Visit My Behance Portfolio</h2>

        <img
          src={behanceImg}
          alt="behance_thumbnail"
          className="portfolioImg"
        />
      </a>
    </Col>

    {/* YouTube */}
    <Col lg={5} md={12}>
      <a
        href="https://www.youtube.com/live/1SnR1Q_wMac?si=9oTUacwv2sk-kjlV"
        target="_blank"
        rel="noopener noreferrer"
        className="portfolioCard"
      >
        <h2 className="sectionTitle">MEET MOMOCODE FINALIST</h2>

        <img
          src={youtubeImg}
          alt="yt_thumbnail"
          className="portfolioImg"
        />
      </a>
    </Col>

  </Row>
</Container>
  )
}
